import React from 'react';
import { GymTvCircle } from '../../../../Components/GymTvCircle';

export const CirclesFactory = ({ type, ...props }) => {
    switch (type) {
        case 0:
            return <GymTvCircle.HeartratePercentage {...props} />;
        case 1:
            return <GymTvCircle.Calories {...props} />;
        case 2:
            return <GymTvCircle.Heartrate {...props} />;
        case 3:
            return <GymTvCircle.Finished {...props} />;
        case 4:
            return <GymTvCircle.NoWatch {...props} />;
        case 5:
            return <GymTvCircle.JoinCircle {...props} />;
        default:
            return <GymTvCircle.HeartratePercentage {...props} />;
    }
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymTv/LiveDisplay/Content/CirclesFactory.js